import React from "react";
import ReactDOM from "react-dom/client";
// Fontsource: self-hosted font packages instead of a Google Fonts CDN
// @import/<link> -- avoids the CDN round-trip (and the layout shift while
// it resolves) and lets each weight actually used be bundled individually
// rather than pulling a whole family's CSS from the network. This set
// covers every font in EditorToolbar's font picker (ArtifactPanel.jsx /
// SplitPanel.jsx FONT_OPTIONS) plus the screenplay/document base fonts;
// Arial and Georgia are system fonts and need no package.
import "@fontsource/courier-prime/400.css";
import "@fontsource/courier-prime/700.css";
import "@fontsource/chivo/300.css";
import "@fontsource/chivo/400.css";
import "@fontsource/chivo/500.css";
import "@fontsource/chivo/600.css";
import "@fontsource/chivo/700.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/cutive-mono/400.css";
import "@fontsource/lora/400.css";
import "@fontsource/lora/600.css";
import "@fontsource/lora/700.css";
import "@fontsource/source-serif-4/400.css";
import "@fontsource/source-serif-4/600.css";
import "@fontsource/source-serif-4/700.css";
import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/600.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/crimson-text/400.css";
import "@fontsource/crimson-text/600.css";
import "@fontsource/crimson-text/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";
import "./index.css";
import App from "./App";
import CardIngestWindow from "./electron/CardIngestWindow";

// The Electron companion control window (and the card-ingest window, same
// pattern) loads this same build (index.html) rather than a separate static
// HTML file, so it gets the app's real React tree/styling — but it renders
// its own component directly, bypassing the BrowserRouter entirely.
// BrowserRouter reads pathname, not a file:// URL's query string in a
// meaningful routable way for a second window, so a query param + early
// bypass here is simpler than fighting the router for a special-purpose
// window (see plugins-pro/companion window loader, card-ingest-window.js).
const windowParam = new URLSearchParams(window.location.search).get("window");
const isCardIngestWindow = windowParam === "card-ingest";

// Suppress ResizeObserver loop limit exceeded errors (common with Floating UI)
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (args[0]?.includes?.('ResizeObserver loop')) {
    return; // Suppress this specific error
  }
  resizeObserverErr(...args);
};

// Additional global error handler for ResizeObserver
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isCardIngestWindow ? <CardIngestWindow /> : <App />}
  </React.StrictMode>
);
